import { render, staticRenderFns } from "./listFriendRecommend.vue?vue&type=template&id=e3fc773c&scoped=true"
import script from "./listFriendRecommend.vue?vue&type=script&lang=js"
export * from "./listFriendRecommend.vue?vue&type=script&lang=js"
import style0 from "./listFriendRecommend.vue?vue&type=style&index=0&id=e3fc773c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3fc773c",
  null
  
)

export default component.exports